export enum BadgeFrameType {
  NONE = 'NONE',
  SHIELD = 'SHIELD',
}

export interface CommunityJSON {
  _id?: string;
  badgeFrameType?: BadgeFrameType | string;
  badgeResource?: {url?: string};
  description?: string;
  id?: string;
  memberCount?: number;
  name?: string;
}

export class Community {
  badgeFrameType: BadgeFrameType;
  badgeUrl: string;
  description: string;
  id: string;
  memberCount: number;
  name: string;

  constructor(json: CommunityJSON) {
    this.id = json.id ?? json._id ?? '';
    this.name = json.name ?? '';
    this.description = json.description ?? '';
    this.memberCount = json.memberCount ?? 0;
    this.badgeUrl = json.badgeResource?.url ?? '';
    this.badgeFrameType =
      json.badgeFrameType === BadgeFrameType.NONE || json.badgeFrameType === 'NONE' ? BadgeFrameType.NONE : BadgeFrameType.SHIELD;
  }

  get displayLabel(): string {
    if (this.memberCount > 0) {
      const count = this.memberCount.toLocaleString();
      return `${this.name || this.id} (${count} member${this.memberCount === 1 ? '' : 's'})`;
    }
    return this.name || this.id;
  }
}
